import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { IVehicleModel } from 'src/app/core/models/vehicle.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { distinctUntilChanged, skipWhile, take } from 'rxjs/operators';
import { IUser } from 'src/app/core/models/user.model';
import { Role } from 'src/app/core/models/role';
import { MessagingService } from 'src/app/core/services/messaging.service';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { VehicleService } from 'src/app/core/services/vehicle.service';
import { featuresWhiteIcons } from 'src/app/core/const/settings';
import { VehicleSpecificationsService } from 'src/app/core/services/vehicle-specifications.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DmsService } from 'src/app/core/services/dms.service';
import { UserService } from 'src/app/core/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-list-vehicles',
  templateUrl: './list-vehicles.component.html',
  styleUrls: ['./list-vehicles.component.css']
})
export class ListVehiclesComponent implements OnInit, OnDestroy {

  @Input() vehicles: IVehicleModel[] = [];
  @Input() customer = false;
  @Input() notifications: any = [];

  @Output() onVehiclePicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRealod: EventEmitter<any> = new EventEmitter<any>();

  user: IUser;
  vehicleStatus = Status;
  notificationStatus = vehicleStatus;
  sub: Subscription;
  importStatus = IMPORT_STATUS;
  selectedVehicle: IVehicleModel = null;
  toggleVehicleDetails = false;
  isLoading = false;
  featuresIcons = featuresWhiteIcons;
  userId: string;
  clientId: string;

  constructor(
    private authService: AuthService,
    private messagingService: MessagingService,
    private vehicleService: VehicleService,
    private vehicleSpecificationsService: VehicleSpecificationsService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private dmsService: DmsService,
    private userService: UserService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.authService.LoggedinUser
      .pipe(
        take(1))
      .subscribe(user => {
        this.user = user;
      });
    this.checkForNotifications();

    if (this.route.snapshot.params.userId) {
      this.userId = this.route.snapshot.params.userId;
      this.userService.getById(this.userId).subscribe(res => {
        this.clientId = res.clientId;
      });
    }

    if (this.user.role.name === 'user') {
      this.clientId = this.user.clientId;
    }

    this.messagingService.receiveMessage();
    this.sub = this.messagingService.currentMessage
      .pipe(
        skipWhile(value => value === null),
        distinctUntilChanged((data, secondData) => data.data === secondData.data)
      )
      .subscribe(message => {
        switch (message.data.event) {
          case this.notificationStatus.VEHICLE_PROCESSED:
          case this.notificationStatus.VEHICLE_IMPORTED:
            this.findVehicle(message.data, Status.COMPLETED);
            break;
          case this.notificationStatus.IMAGE_PROCESSED:
            this.loadImages(message.data);
            break;
        }
      });

    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker.addEventListener('message', (event) => {
    //     this.messagingService.currentMessage.next(event.data);
    //   });
    // }
  }

  findVehicle(data, status) {
    console.log('vehicle processed')
    const vehicle = this.vehicles.find(vehicle => vehicle.vehicleId === data.vehicleId);

    if (vehicle) {
      vehicle.vehicleInfo.status = status;
    }

    if (vehicle.vehicleInfo.processing === 0) {
      setTimeout(() => {
        this.vehicleService.getVehicleByUserId(vehicle.userId, vehicle.vehicleId)
          .subscribe(
            res => {
              const index = this.vehicles.findIndex(vehicle => vehicle.vehicleId === res.vehicleId);

              if (index !== -1) {
                this.vehicles[index] = res;
                this.vehicles[index].previewPicture = res.coverImage.previewFile.thumbnailPath;;
              }
            }
          );
      }, 2500);
    }
  }

  loadImages(data) {
    console.log('image processed')
    let vehicle = this.vehicles.find(vehicle => vehicle.vehicleId === data.vehicleId);

    if (vehicle && vehicle.vehicleInfo.processing > 0) {
      vehicle.vehicleInfo.processing--;

      console.log(vehicle.vehicleInfo.processing)

      if (vehicle.vehicleInfo.processing < 1 && this.notifications.length) {

        this.notifications = this.notifications.filter(notification => notification.data.vehicleId !== vehicle.vehicleId);
        this.notifications = this.notifications.filter(notification => notification.data.event === this.notificationStatus.IMAGE_PROCESSED);

        console.log(this.notifications)

      } // if less than 1, clear notifications array 

      // if (vehicle.vehicleInfo.processing === 0) {
      //   setTimeout(() => {
      //     this.vehicleService.getVehicleByUserId(vehicle.userId, vehicle.vehicleId)
      //       .subscribe(
      //         res => {
      //           const index = this.vehicles.findIndex(vehicle => vehicle.vehicleId === res.vehicleId);

      //           if (index !== -1) {
      //             this.vehicles[index] = res;
      //             this.vehicles[index].previewPicture = res.coverImage.previewFile.thumbnailPath;;
      //           }
      //         }
      //       );
      //   }, 2500);
      // }
    }
  }

  checkForNotifications() {
    if (this.notifications.length) {
      this.notifications.forEach(notification => {
        if (notification.data.event === this.notificationStatus.IMAGE_PROCESSED) {
          this.loadImages(notification.data);
        } else if (notification.data.event === this.notificationStatus.VEHICLE_PROCESSED) {
          this.findVehicle(notification.data, Status.COMPLETED);
        }
      })

      this.notifications = [];
    }
  }

  navigateToVehicle(vehicle: IVehicleModel) {
    this.onVehiclePicked.emit(vehicle);
  }

  reloadVehicles() {
    this.onRealod.emit();
  }

  countExterior(vehicle: IVehicleModel) {

    let count = 0;

    if (vehicle.imageCount.exterior) { count = vehicle.imageCount.exterior; }

    if (vehicle.imageCount.collage) { count++; }
    if (vehicle.imageCount.gif) { count++; }

    return count;

  }
  countInterior(vehicle: IVehicleModel) {
    let count = 0;

    if (vehicle.imageCount.interior) { count = vehicle.imageCount.interior; }
    if (vehicle.imageCount.panorama_front){ count += vehicle.imageCount.panorama_front; }
    if (vehicle.imageCount.panorama_back){ count += vehicle.imageCount.panorama_back; }

    return count;
  }
  countDetails(image: IVehicleModel) {
    let count = 0;

    if (image.imageCount.details) { count = image.imageCount.details; }

    if (image.imageCount.fillableImage) { count = count + image.imageCount.fillableImage }

    return count;
  }

  countVideo(image: IVehicleModel) {
    let count = 0;
    if (image.imageCount['360_exterior']) { count += image.imageCount['360_exterior'] }
    if (image.imageCount['360_interior']) { count += image.imageCount['360_interior'] }
    if (image.imageCount.video) { count += image.imageCount.video; }
    return count;
  }

  isVisible() {
    if (this.user.role.name === Role.ROOT) {
      return true;
    } else {
      return this.customer && ['customer', 'client'].includes(this.user.role.name);
    }
  }

  isVisibleRefresh(): boolean {
    return Notification.permission !== "granted" || ['client', 'customer', 'root'].includes(this.user.role.name)
  }

  onVehicleDetails(vehicle: IVehicleModel) {
    if (this.isLoading) return;

    this.isLoading = true;
    this.vehicleService.getVehicleByUserId(vehicle.userId, vehicle.vehicleId)
      .subscribe(
        res => {
          this.selectedVehicle = res;
          this.toggleVehicleDetails = true;
          this.isLoading = false;
        },
        err => {
          this.isLoading = false;
        }
      );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.messagingService.currentMessage.next(null);
  }

  toggleVehicleSpecifications = false;
  vehicleSpecifications: any = {};
  vehicleSpecificationsFields: any = [];
  mappedVehicleFields: any[] = [];
  equipments: any;
  profiles: any[] = [];;
  clientDms: any = [];;
  vehicleProfile: any = [];;
  selectedEquipmentIds: string[] = [];
  isEditMode: boolean = false;
  isLoadingSpecifications = false;
  requiredFields: any = [];

  isFeatureIncluded(features: string[], featureList: string[]): boolean {
    return featureList.some(feature => features.includes(feature));
  }

  onVehicleSpecifications(vehicle) {
    this.toggleVehicleSpecifications = true;
    this.isEditMode = false;
    this.isLoadingSpecifications = true;

    forkJoin({
      specs: this.loadSpecifications(vehicle.userId, vehicle.vehicleId),
      fields: this.loadSpecificationsFields(),
      profiles: this.loadProfiles(vehicle.userId),
      equipments: this.loadEquipments(),
      clientDMS: this.loadClientDms(vehicle.user?.clientId || this.clientId)
    }).subscribe(({ specs, fields, profiles, equipments, clientDMS }) => {
      this.vehicleSpecifications = specs;
      this.vehicleSpecifications.userId = vehicle.userId;
      this.vehicleSpecificationsFields = fields;
      this.selectedEquipmentIds = (specs.equipment || []).map(e => e.id);
      this.profiles = profiles;
      this.equipments = equipments;
      this.clientDms = clientDMS;

      this.checkVehicleProfile(vehicle, profiles);
      this.mapVehicleFields();

      this.isLoadingSpecifications = false;
    });
  }

  loadSpecifications(userId: string, vehicleId: string): Observable<any> {
    return this.vehicleService.getVehicleSpecifications(userId, vehicleId);
  }

  loadSpecificationsFields(): Observable<any> {
    return this.vehicleSpecificationsService.getVehicleSpecificationsFields(this.translate.currentLang);
  }

  loadEquipments(): Observable<any> {
    return this.vehicleSpecificationsService.getEquipments(this.translate.currentLang);
  }

  loadProfiles(userId): Observable<any> {
    return this.userService.getSettingsProfiles(userId);
  }

  loadClientDms(clientId): Observable<any> {
    return this.dmsService.getClientDMS(clientId);
  }

  checkVehicleProfile(vehicle, profiles) {
    const profile = profiles.find(
      (profile) => profile.id === vehicle.vehicleInfo.profileId
    );

    if (profile) {
      this.vehicleProfile = profile;
    }
  }

  getRequiredSpecificationFieldsFromDms(): string[] {
    let requiredFields: string[] = [];
    const clientRequiredFields: string[] = [];
    const profileRequiredFields: string[] = [];
    if (this.clientDms?.dms) {
      this.clientDms.dms.forEach(dmsObj => {
        if (dmsObj.dms.supports?.includes('specification')) {
          const requiredFields = dmsObj.settings?.requiredVehicleSpecificationFields || [];
          clientRequiredFields.push(...requiredFields);
        }
      });
    }
  
    if (this.vehicleProfile?.dms) {
      this.vehicleProfile.dms.forEach(dmsObj => {
        if (dmsObj.dms.supports?.includes('specification')) {
          const requiredFields = dmsObj.settings?.requiredVehicleSpecificationFields || [];
          profileRequiredFields.push(...requiredFields);
        }
      });
    }

    this.requiredFields = [...new Set([...clientRequiredFields, ...profileRequiredFields])];
  
    return requiredFields;
  }

  mapVehicleFields() {
    this.getRequiredSpecificationFieldsFromDms();

    this.mappedVehicleFields = this.vehicleSpecificationsFields
      .filter(field => field.name !== 'description')
      .map(field => {
        let value = this.vehicleSpecifications[field.name];
        let displayValue = value;

        if (!this.isEditMode) {
          if (field.type === 'boolean') {
            displayValue = value === true ? 'Yes' : value === false ? 'No' : '/';
          } else if (value == null || value === '') {
            displayValue = '/';
          }
        } else {
          if (field.type === 'date' && typeof value === 'string') {
            const parts = value.split('-');
            if (parts.length === 3) {
              displayValue = {
                year: parseInt(parts[0], 10),
                month: parseInt(parts[1], 10),
                day: parseInt(parts[2], 10)
              };
            }
          }
        }
  
        const isFieldRequired = this.requiredFields.includes(field.name);
  
        return {
          label: field.translations?.[0]?.name || field.name,
          value: displayValue,
          name: field.name,
          type: field.type,
          isRequired: isFieldRequired,
          unit: field.unit,
        };
      });
  }
  
  toggleEditMode() {
    this.isEditMode = !this.isEditMode;
    this.mapVehicleFields();
  }

  onEquipmentsChange(eqId: string, isChecked: boolean): void {
    if (isChecked) {
      this.selectedEquipmentIds.push(eqId);
    } else {
      this.selectedEquipmentIds = this.selectedEquipmentIds.filter(
        (id) => id !== eqId
      );
    }
  }

  isEquipmentSelected(name: string): boolean {
    return this.selectedEquipmentIds?.includes(name);
  }

  convertToDateString(ngbDate: NgbDateStruct): string {
    if (!ngbDate) return null;
    const year = ngbDate.year;
    const month = ngbDate.month < 10 ? `0${ngbDate.month}` : ngbDate.month;
    const day = ngbDate.day < 10 ? `0${ngbDate.day}` : ngbDate.day;
    return `${year}-${month}-${day}`;
  }

  saveSpecifications(form: NgForm) {
    if (!form.valid) {
      this.toastr.error('Please fill in all required fields.');
      return;
    }

    const specifications: any = {};

    this.mappedVehicleFields.forEach(field => {
      let value = field.value ?? null;

      if (field.type === 'date' && value) {
        value = this.convertToDateString(value);
      }
      specifications[field.name] = value;
    });

    const description = this.vehicleSpecifications?.description?.trim();
    specifications['description'] = description || null;

    if (Object.keys(specifications).length === 0) {
      this.toastr.error('No valid data to save.');
      return;
    }

    const requests = [];

    requests.push(
      this.vehicleService.updateVehicleSpecifications(this.vehicleSpecifications.userId, this.vehicleSpecifications.vehicleId, specifications)
    );

    if (this.selectedEquipmentIds && this.selectedEquipmentIds.length > 0) {
      requests.push(
        this.vehicleService.updateVehicleEquipments(this.vehicleSpecifications.userId, this.vehicleSpecifications.vehicleId, {
          equipmentIds: this.selectedEquipmentIds
        })
      );
    }

    forkJoin(requests).subscribe({
      next: () => {
        this.toastr.success('Saved successfully');
        this.toggleVehicleSpecifications = false;
      },
      error: (error) => {
        this.toastr.error('Failed to save');
      }
    });
  }

    changeVehicleStatus(vehicle: any, status: Status) {
      const body = {
        status: status
      };
      this.vehicleService
        .updateVehicleStatus(vehicle.userId, vehicle.vehicleId, body)
        .subscribe({
          next: () => {
            vehicle.vehicleInfo.status = status;
          },
          error: (err) => {
            console.error(err);
          }
        });
    }
}

enum Status {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PENDING = 'pending',
  PROCESSING = 'processing',
  QC = 'qc',
  UNPROCESSED = 'unprocessed'
}

enum vehicleStatus {
  IMAGE_PROCESSED = "image.processed",
  VEHICLE_PROCESSED = "vehicle.processed",
  VEHICLE_IMPORTED = "vehicle.images.imported"
}

enum IMPORT_STATUS {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PENDING = 'pending',
  IMPORTING = 'importing',
  NOT_IMPORTED = 'not_imported',
  NOT_AVAILABLE = 'not_available'
}
